import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import Breakfast from '../assets/Breakfast item.png'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTrainerMainMeals } from '../hooks/MainMeals'
function Meals() {
  const dispatch = useDispatch()
  const { list: weekList } = useSelector((state) => state.week);
  const { list: MainMealsList, Pagination: MainMealsPagination } = useSelector((state) => state.mainMeals);
  const subcategories = MainMealsList.filter((meal) => meal.parent_id !== null)
  const { list: profile } = useSelector((state) => state.Profile)
  console.log(profile);

  useEffect(() => {
    dispatch(fetchTrainerMainMeals(profile?.restaurant?.id))
  }, [])
  const today = new Date();
  const todayStr = new Date().toISOString()?.split("T")[0];

  const result = weekList.find(item => {
    const start = item.start_date?.split("T")[0];
    const end = item.end_date?.split("T")[0];

    return todayStr >= start && todayStr <= end;
  });
  console.log(result);


  const header = [
    "صورة الصنف",
    "اسم الصنف",
    "التصنيف",
    "تاريخ الاضافة",
    "الحالة",

    "",


  ]
  const studentsData = [
    { id: 1, name: 'بيض', category: 'فطار', date: "13/4/2025 22:00", image: Breakfast, active: "true" },
    { id: 2, name: 'سمك', category: 'غذاء', date: "13/4/2025 22:00", image: Breakfast, active: "false" },
    { id: 3, name: 'جبن', category: 'عشاء', date: "13/4/2025 22:00", image: Breakfast, active: "true" },
  ]
  const fiteration = [
    { id: 0, title: "الوجبات", options: [{ id: "01", title: "الافطار" }, { id: "02", title: "الغداء" }, { id: "03", title: "العشاء" }] },
  ]
  return (
    <>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={`قائمة الطعام ${result?.start_date.slice(0, 10)} _______  ${result?.end_date.slice(0, 10)}`}
          subtitle={""}
          downloadData={false}
          addData={false}
          status={"meal"}


        />
        <Row className='mt-5 mx-4'>
          <Col md={4}>
            <div className='body_container'>
              <strong className='mb-3'>الافطار</strong>
              <div className='d-flex align-items-center mt-4'>
                {subcategories.filter((meal) => meal.parent_id == 10).map((item) => {
                  return (
                    <div>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      <p>{item?.description}</p>
                    </div>
                  )
                })}
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className='body_container'>
              <strong className='mb-3'>الغداء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 11).map((item) => {
                  console.log(item);
                  return (
                    <div className='mx-2'>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      <p>{item?.description}</p>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className='body_container'>
              <strong className='mb-3'>العشاء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 12).map((item) => {
                  return (
                    <div>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      <p>{item?.description}</p>
                    </div>)
                }
                )}
              </div>
            </div>
          </Col>
        </Row>
        {/* <div className='meals_container'>
          {subcategories.filter((meal) => meal.parent_id == 10).length>0&&
          <div className='body_container' style={{ width: "30%" }}>
            <strong className='mb-3'>الافطار</strong>
            <div className='d-flex align-items-center mt-4'>
              {subcategories.filter((meal) => meal.parent_id == 10).map((item) => {

                return (
                  <div>
                    <img src={item.image} alt="meal" className='w-100' />
                    <h5>{item.name}</h5>
                    <p>{item?.description}</p>
                  </div>
                )
              })}
            </div>

          </div>
}
          {subcategories.filter((meal) => meal.parent_id == 11).length > 0 &&
            <div className='body_container' style={{ width: "30%" }}>
              <strong className='mb-3'>الغداء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 11).map((item) => {
                  console.log(item);

                  return (
                    <div className='mx-2'>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      <p>{item?.description}</p>
                    </div>
                  )
                })}
              </div>
            </div>

          }
          {subcategories.filter((meal) => meal.parent_id == 12).length > 0 &&
            <div className='body_container' style={{ width: "30%" }}>
              <strong className='mb-3'>العشاء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 12).map((item) => {
                  return (
                    <div>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      <p>{item?.description}</p>
                    </div>)
                })}
              </div>
            </div>
          }

        </div> */}
        {/* <Row className='mt-5 mx-4'>
<Col md={4}>
<div className='body_container'>
<strong className='mb-3'>الافطار</strong>

</div>
</Col>
<Col md={4}>fdsk</Col>
<Col md={4}>fdsk</Col>
</Row> */}
      </Container>
    </>
    // <div>
    //   <AuthNavbar />
    //   <Container>
    // <CustomHeader
    //   title={"قائمة الطعام"}
    //   subtitle={""}
    //   downloadData={false}
    //   addData={true}
    //   status={"meal"}


    // />
    //     <CustomTable
    //       data={studentsData}
    //       fiteration={fiteration}
    //       currentData={25}
    //       allData={' 1,248  مستفيد'}
    //       header={header}
    //       actions={["تعديل", "حذف"]}
    //       status={"meal"}

    //     />
    //     <CustomPagination
    //       currentData={1}
    //       allData={25}
    //       datainPage={5}

    //     />
    //   </Container>
    // </div>
  )
}

export default Meals